export const IMAGE_EDITING_FEATURES = {
	REMOVE_BACKGROUND: "removeBackground",
	BLUR_BACKGROUND: "blurBackground",
	EXPAND_BACKGROUND: "expandBackground",
	GENERATE_BACKGROUND_BY_TEXT: "generateBackgroundByText",
	GENERATE_BACKGROUND_BY_IMAGE: "generateBackgroundByImage",
	SOLID_BACKGROUND: "solidBackground",
	FOREGROUND_PLACEMENT: "foregroundPlacement",
	ERASE_OBJECT: "eraseObject",
	GENERATIVE_FILL: "generativeFill",
	CHANGE_ASPECT_RATIO: "changeAspectRatio",
	MEDIUM_DESTINATION: "mediumDestination",
	INCREASE_RESOLUTION: "increaseResolution",
	CUSTOM_SIZE: "customSize",
	IMAGE_EDITING: "imageEditing",
	BULK_IMAGE_EDITING: "bulkImageEditing",
	CROP_IMAGE: "cropImage",
} as const;

export type ImageEditingFeature = (typeof IMAGE_EDITING_FEATURES)[keyof typeof IMAGE_EDITING_FEATURES];

export const imageGenerationRoutes = [
	"prompt_enhancer",
	"text-to-vector/base/32",
	"text-to-vector/base/23",
	"text-to-vector/fast/23",
	"text-to-image/base/32",
	"text-to-image/base/22",
	"text-to-image/base/23",
	"text-to-image/fast/22",
	"text-to-image/fast/23",
	"text-to-image/hd",
	"reimagine",
	"refine_faces",
	"restyle_portrait",
	"structured_prompt/generate",
	"image/generate",
	"structured_prompt/generate-lite",
	"Text-To-Image/Fibo_lite",
	"structured_prompt/generate_from_diff",
];

export const imageEditingRoutes = [
	"erase_foreground",
	"eraser",
	"background/remove",
	"background/remove/guided",
	"background/remove/prompt",
	"background/blur",
	"replace_bg",
	"expand",
	"increase_resolution",
	"crop_foreground",
	"face",
	"gen_fill",
	"enhance_image",
	"image/edit",
	"structured_instruction/generate",
	"erase_by_text",
	"rewrite_text",
	"replace_object_by_text",
	"sketch_to_colored_image",
	"add_object_by_text",
	"reseason",
	"restyle",
	"colorize",
	"blend",
	"restore",
	"relight",
	"image/segment/all_masks",
	"lora/image/edit",
];

export const videoEditingRoutes = [
	"video/background/remove",
	"video/edit/increase_resolution",
	"image-to-video/tailored",
	"video/edit/erase",
	"video/edit/green_screen",
	"video/edit/replace_background",
	"video/segment/mask_by_prompt",
	"video/segment/mask_by_key_points",
	"video/generate/foreground_mask",
];

export const productGenRoutes = [
	"product/cutout",
	"product/packshot",
	"product/integrate",
	"product/shadow",
	"product/lifestyle_shot_by_text",
	"product/lifestyle_shot_by_image",
	"vehicle/shot_by_text",
	"vehicle/segment",
	"vehicle/harmonize",
	"vehicle/apply_effect",
	"vehicle/refine_tires",
	"vehicle/generate_reflections",
	"vehicle/shot_by_image",
	"product/holding",
	"product/virtual_tryon",
];

export const tailoredGenRoutes = ["text-to-image/tailored", "text-to-vector/tailored"];

export const adGenerationRoutes = ["ads/generate", "ads/delayer"];

export const otherRoutes = ["style", "image_to_psd"];

export type RouteGroupKey =
	| "image_generation"
	| "video_editing"
	| "image_editing"
	| "product_shot_editing"
	| "tailored_generation"
	| "ads_generation"
	| "others";

export const productGroupRouteMap: Record<RouteGroupKey, string[]> = {
	image_generation: imageGenerationRoutes,
	image_editing: imageEditingRoutes,
	video_editing: videoEditingRoutes,
	product_shot_editing: productGenRoutes,
	tailored_generation: tailoredGenRoutes,
	ads_generation: adGenerationRoutes,
	others: otherRoutes,
};

export const routeToGroup: Record<string, string> = (() => {
	const map: Record<string, string> = {};
	Object.entries(productGroupRouteMap).forEach(([group, routes]) => {
		routes.forEach((route) => {
			map[route] = group;
		});
	});
	return map;
})();
